import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'kh-card',
  styleUrls: ['./card.component.less'],
  templateUrl: './card.component.html',
  standalone: false
})
export class CardComponent implements OnInit {
  @Input() public text: string | undefined = undefined;
  @Input() public iconUrl: string | undefined = undefined;
  @Input() public width = 140;
  @Input() public height = 140;
  @Input() public isSelected = false;

  public showIcon = false;

  public ngOnInit(): void {
    this.showIcon = !!this.iconUrl;
  }
}
